"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var ReportRequestTypeEnum;
(function (ReportRequestTypeEnum) {
    ReportRequestTypeEnum["ALL"] = "all";
    ReportRequestTypeEnum["PAGINATED"] = "paginated";
})(ReportRequestTypeEnum = exports.ReportRequestTypeEnum || (exports.ReportRequestTypeEnum = {}));
var ILTLearnerTypeEnum;
(function (ILTLearnerTypeEnum) {
    ILTLearnerTypeEnum["PUBLISHER"] = "publisher";
    ILTLearnerTypeEnum["VIEWER"] = "viewer";
    ILTLearnerTypeEnum["NONE"] = "none";
    ILTLearnerTypeEnum["UNASSIGNED_VIEWER"] = "unassignedViewer";
})(ILTLearnerTypeEnum = exports.ILTLearnerTypeEnum || (exports.ILTLearnerTypeEnum = {}));
var ILTRegisterTypeEnums;
(function (ILTRegisterTypeEnums) {
    ILTRegisterTypeEnums["ASSIGNED"] = "assigned";
    ILTRegisterTypeEnums["NOT_REGISTERED"] = "notRegistered";
    ILTRegisterTypeEnums["WAIT_LISTED"] = "waitListed";
    ILTRegisterTypeEnums["ENROLLED"] = "enrolled";
})(ILTRegisterTypeEnums = exports.ILTRegisterTypeEnums || (exports.ILTRegisterTypeEnums = {}));
var ContentTypeEnum;
(function (ContentTypeEnum) {
    ContentTypeEnum["ASSIGNMENT_CARD"] = "assignmentCard";
    ContentTypeEnum["CARD_QUESTION"] = "cardQuestion";
    ContentTypeEnum["CARD_QUESTION_FOR_REVIEW"] = "cardQuestionForReview";
    ContentTypeEnum["CHANNEL"] = "channel";
    ContentTypeEnum["CHANNEL_CARD"] = "channelCard";
    ContentTypeEnum["CHECKPOINT"] = "checkpoint";
    ContentTypeEnum["COURSE"] = "course";
    ContentTypeEnum["OFFER"] = "offer";
    ContentTypeEnum["CURRICULUM"] = "curriculum";
    ContentTypeEnum["CURRICULUM_OFFER"] = "curriculumOffer";
    ContentTypeEnum["GENERIC"] = "generic";
    ContentTypeEnum["ILT"] = "liveTraining";
    ContentTypeEnum["LEARNING_CARD"] = "learningCard";
    ContentTypeEnum["PEER_QUESTION"] = "peerQuestion";
    ContentTypeEnum["PEER_REVIEW_CARD"] = "peerReviewCard";
    ContentTypeEnum["SECTION"] = "section";
    ContentTypeEnum["SKILL"] = "skill";
})(ContentTypeEnum = exports.ContentTypeEnum || (exports.ContentTypeEnum = {}));
var LiveClassIdFilterEnum;
(function (LiveClassIdFilterEnum) {
    LiveClassIdFilterEnum["CLASS_ID"] = "classId";
})(LiveClassIdFilterEnum = exports.LiveClassIdFilterEnum || (exports.LiveClassIdFilterEnum = {}));
var CommonFilterEnum;
(function (CommonFilterEnum) {
    CommonFilterEnum["ID"] = "id";
    CommonFilterEnum["COMPANY_ID"] = "companyId";
    CommonFilterEnum["COMPANY_IDS"] = "companyIds";
    CommonFilterEnum["GROUP_ID"] = "groupIds";
    CommonFilterEnum["DYNAMIC_GROUP_ID"] = "dynamicGroupIds";
    CommonFilterEnum["CUSTOM_PROPERTY"] = "customProperties";
    CommonFilterEnum["ASSIGN_TYPE"] = "currentEnrolmentInfo.assignType";
    CommonFilterEnum["DELETED"] = "deleted";
})(CommonFilterEnum = exports.CommonFilterEnum || (exports.CommonFilterEnum = {}));
var StateFilterEnum;
(function (StateFilterEnum) {
    StateFilterEnum["ASSIGNMENT_EVENT_ID"] = "enrolmentInfo.assignmentEventId";
    StateFilterEnum["LEARNER_TYPE"] = "learnerType";
    StateFilterEnum["REGISTER_TYPE"] = "registerType";
})(StateFilterEnum = exports.StateFilterEnum || (exports.StateFilterEnum = {}));
var ContentFilterEnum;
(function (ContentFilterEnum) {
    ContentFilterEnum["CONTENT_TYPE"] = "contentType";
    ContentFilterEnum["CONTENT_ID"] = "contentId";
    ContentFilterEnum["ROOT_CONTENT_ID"] = "rootContentId";
    ContentFilterEnum["USER_ID"] = "userId";
    ContentFilterEnum["PARENT_IDS"] = "parentIds";
    ContentFilterEnum["USERID_CONTENTID"] = "userId_contentId";
    ContentFilterEnum["ILT_SESSION_ID"] = "sessionId";
    ContentFilterEnum["DIRECT"] = "direct";
    ContentFilterEnum["UNPUBLISHED"] = "isUnpublished";
    ContentFilterEnum["CONTENT_CREATOR_ID"] = "content.creatorId";
    ContentFilterEnum["DRAFT"] = "isDraft";
})(ContentFilterEnum = exports.ContentFilterEnum || (exports.ContentFilterEnum = {}));
var AssignmentEventFilterEnum;
(function (AssignmentEventFilterEnum) {
    AssignmentEventFilterEnum["ASSIGNMENT_EVENT_TYPE"] = "assignmentEventType";
    AssignmentEventFilterEnum["DRAFT"] = "draft";
    AssignmentEventFilterEnum["STATUS"] = "status";
    AssignmentEventFilterEnum["CREATED_BY"] = "createdBy";
})(AssignmentEventFilterEnum = exports.AssignmentEventFilterEnum || (exports.AssignmentEventFilterEnum = {}));
var UserFilterEnum;
(function (UserFilterEnum) {
    UserFilterEnum["ID"] = "id";
    UserFilterEnum["USER_ID"] = "userId";
    UserFilterEnum["USER_IDS"] = "userIds";
    UserFilterEnum["UNIQUE_ID"] = "uniqueId";
    UserFilterEnum["COMPANY_ID"] = "companyId";
    UserFilterEnum["CREATOR_ID"] = "creatorId";
    UserFilterEnum["CREATED_BY"] = "createdBy";
    UserFilterEnum["STATUS"] = "status";
})(UserFilterEnum = exports.UserFilterEnum || (exports.UserFilterEnum = {}));
var DashboardFilterEnum;
(function (DashboardFilterEnum) {
    DashboardFilterEnum["REPORT_TYPE"] = "reportConfigs.reportType";
    DashboardFilterEnum["USER_GROUP_IDS"] = "userGroupIds";
})(DashboardFilterEnum = exports.DashboardFilterEnum || (exports.DashboardFilterEnum = {}));
var GroupFilterEnum;
(function (GroupFilterEnum) {
    GroupFilterEnum["GROUP_TYPE"] = "groupType";
    GroupFilterEnum["SYSTEM_GENERATED"] = "systemGenerated";
})(GroupFilterEnum = exports.GroupFilterEnum || (exports.GroupFilterEnum = {}));
var GroupTypeEnum;
(function (GroupTypeEnum) {
    GroupTypeEnum["USER_GROUP"] = "user";
    GroupTypeEnum["CONTENT_GROUP"] = "content";
})(GroupTypeEnum = exports.GroupTypeEnum || (exports.GroupTypeEnum = {}));
var RangeFilterEnum;
(function (RangeFilterEnum) {
    RangeFilterEnum["COMPLETED_ON"] = "completedOn";
    RangeFilterEnum["CREATED_AT"] = "createdAt";
    RangeFilterEnum["ASSIGNED_ON"] = "currentEnrolmentInfo.assignDate";
    RangeFilterEnum["DUE_DATE"] = "currentEnrolmentInfo.dueDate";
    RangeFilterEnum["UPDATE_AT"] = "updatedAt";
    RangeFilterEnum["LAST_ACCESSED_ON"] = "lastAccessedOn";
    RangeFilterEnum["LAST_UPDATED_AT"] = "lastUpdated";
})(RangeFilterEnum = exports.RangeFilterEnum || (exports.RangeFilterEnum = {}));
var ContentVersionLogFilterEnum;
(function (ContentVersionLogFilterEnum) {
    ContentVersionLogFilterEnum["ACTOR_ID"] = "actorId";
    ContentVersionLogFilterEnum["VERSION_ID"] = "versionId";
})(ContentVersionLogFilterEnum = exports.ContentVersionLogFilterEnum || (exports.ContentVersionLogFilterEnum = {}));
var StateInteractionFilterEnum;
(function (StateInteractionFilterEnum) {
    StateInteractionFilterEnum["ACTOR_ID"] = "actorId";
    StateInteractionFilterEnum["INTERACTING_ON_ID"] = "interactingOnId.keyword";
    StateInteractionFilterEnum["INTERACTION_TYPE"] = "interactionType";
    StateInteractionFilterEnum["QUESTION_ID"] = "questionId";
})(StateInteractionFilterEnum = exports.StateInteractionFilterEnum || (exports.StateInteractionFilterEnum = {}));
var StatusFilterEnum;
(function (StatusFilterEnum) {
    StatusFilterEnum["SUCCESS_STATUS"] = "successStatus";
    StatusFilterEnum["COMPLETION_STATUS"] = "completionStatus";
    StatusFilterEnum["PROGRESS_STATUS"] = "progressStatus";
})(StatusFilterEnum = exports.StatusFilterEnum || (exports.StatusFilterEnum = {}));
var SuccessStatusValuesEnum;
(function (SuccessStatusValuesEnum) {
    SuccessStatusValuesEnum["PASS"] = "pass";
    SuccessStatusValuesEnum["FAIL"] = "fail";
    SuccessStatusValuesEnum["NA"] = "na";
})(SuccessStatusValuesEnum = exports.SuccessStatusValuesEnum || (exports.SuccessStatusValuesEnum = {}));
var CompletionStatusValuesEnum;
(function (CompletionStatusValuesEnum) {
    CompletionStatusValuesEnum["COMPLETED"] = "complete";
    CompletionStatusValuesEnum["INCOMPLETE"] = "inComplete";
    CompletionStatusValuesEnum["NOT_ATTEMPTED"] = "notAttempted";
})(CompletionStatusValuesEnum = exports.CompletionStatusValuesEnum || (exports.CompletionStatusValuesEnum = {}));
var ProgressStatusValuesEnum;
(function (ProgressStatusValuesEnum) {
    ProgressStatusValuesEnum["APPROVED"] = "approved";
    ProgressStatusValuesEnum["REJECTED"] = "rejected";
    ProgressStatusValuesEnum["PENDING"] = "pending";
    ProgressStatusValuesEnum["NOT_SUBMITTED"] = "notSubmitted";
    ProgressStatusValuesEnum["NOT_REGISTERED"] = "notRegistered";
    ProgressStatusValuesEnum["REGISTERED"] = "registered";
    ProgressStatusValuesEnum["COMPLETED"] = "completed";
})(ProgressStatusValuesEnum = exports.ProgressStatusValuesEnum || (exports.ProgressStatusValuesEnum = {}));
var SortFieldEnum;
(function (SortFieldEnum) {
    SortFieldEnum["TIME_SPENT"] = "timeSpent";
    SortFieldEnum["STARTED_ON"] = "startedOn";
    SortFieldEnum["COMPLETED_ON"] = "completedOn";
    SortFieldEnum["CREATED_AT"] = "createdAt";
    SortFieldEnum["UPDATED_AT"] = "updatedAt";
    SortFieldEnum["ASSIGN_DATE"] = "currentEnrolmentInfo.assignDate";
    SortFieldEnum["DUE_DATE"] = "currentEnrolmentInfo.dueDate";
})(SortFieldEnum = exports.SortFieldEnum || (exports.SortFieldEnum = {}));
var UserSortFieldEnum;
(function (UserSortFieldEnum) {
    UserSortFieldEnum["NAME"] = "nameSort";
    UserSortFieldEnum["LAST_ACTIVE"] = "lastActive";
})(UserSortFieldEnum = exports.UserSortFieldEnum || (exports.UserSortFieldEnum = {}));
var ContentSortFieldEnum;
(function (ContentSortFieldEnum) {
    ContentSortFieldEnum["NAME"] = "nameSort.keyword";
})(ContentSortFieldEnum = exports.ContentSortFieldEnum || (exports.ContentSortFieldEnum = {}));
var ContentVersionLogSortFieldEnum;
(function (ContentVersionLogSortFieldEnum) {
    ContentVersionLogSortFieldEnum["NAME"] = "nameSort";
    ContentVersionLogSortFieldEnum["CREATED_AT"] = "createdAt";
})(ContentVersionLogSortFieldEnum = exports.ContentVersionLogSortFieldEnum || (exports.ContentVersionLogSortFieldEnum = {}));
var LiveClassSortFieldEnum;
(function (LiveClassSortFieldEnum) {
    LiveClassSortFieldEnum["NAME"] = "nameSort";
    LiveClassSortFieldEnum["CREATED_AT"] = "createdAt";
})(LiveClassSortFieldEnum = exports.LiveClassSortFieldEnum || (exports.LiveClassSortFieldEnum = {}));
var SortOrderEnum;
(function (SortOrderEnum) {
    SortOrderEnum["ASCENDING"] = "asc";
    SortOrderEnum["DESCENDING"] = "desc";
})(SortOrderEnum = exports.SortOrderEnum || (exports.SortOrderEnum = {}));
var AssignTypeValuesEnum;
(function (AssignTypeValuesEnum) {
    AssignTypeValuesEnum["ASSIGNED"] = "assigned";
    AssignTypeValuesEnum["ENROLLED"] = "enrolled";
    AssignTypeValuesEnum["AUTO_ASSIGNED"] = "autoAssign";
})(AssignTypeValuesEnum = exports.AssignTypeValuesEnum || (exports.AssignTypeValuesEnum = {}));
var StateInteractionTypeEnum;
(function (StateInteractionTypeEnum) {
    StateInteractionTypeEnum["EVALUATION"] = "evaluation";
    StateInteractionTypeEnum["GRADE"] = "grade";
    StateInteractionTypeEnum["PEER_REVIEW"] = "peerReview";
    StateInteractionTypeEnum["FEEDBACK"] = "feedback";
})(StateInteractionTypeEnum = exports.StateInteractionTypeEnum || (exports.StateInteractionTypeEnum = {}));
var UserStatusEnum;
(function (UserStatusEnum) {
    UserStatusEnum["DELETED"] = "deleted";
    UserStatusEnum["INVITED"] = "invited";
})(UserStatusEnum = exports.UserStatusEnum || (exports.UserStatusEnum = {}));
exports.RelatedUserFieldEnum = Object.freeze({
    REVIEWER: { getPath: 'submissions[0].reviewerId', setPath: 'submissions[0].reviewer' },
    ASSIGNER: { getPath: 'currentEnrolmentInfo.assignerId', setPath: 'currentEnrolmentInfo.assigner' },
    CONTENT_CREATOR: { getPath: 'content.creatorId', setPath: 'content.creator' },
    CREATOR: { getPath: 'createdBy', setPath: 'creator' },
    CONTENT_PUBLISHER: { getPath: 'actorId', setPath: 'actor' },
    GRADER: { getPath: 'submissions[0].gradedBy', setPath: 'submissions[0].grader' },
    STATEINTERACTION_ACTOR: { getPath: 'actorId', setPath: 'actor' }
});
exports.RelatedGroupFieldEnum = Object.freeze({
    STATIC_GROUP: { getPath: 'groupIds', setPath: 'groups' },
    DYNAMIC_GROUP: { getPath: 'dynamicGroupIds', setPath: 'dynamicGroups' }
});
exports.RelatedContentFieldEnum = Object.freeze({});
exports.RelatedStateFieldEnum = Object.freeze({
    ROOT_STATE: { getPath: 'rootContentId', setPath: 'rootState' }
});
//# sourceMappingURL=ReportingEnums.js.map